import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { withRouter } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import langFa from "../assets/images/iran.png";
import langEn from "../assets/images/eng.svg";
import langKu from "../assets/images/kurd.png";
import langTajik from "../assets/images/tajik.png";
import { ModalComp } from "../shared";
import { TermsAndConditions, PrivacyPolicy } from "./";
import i18n from "../i18n/locales/config";
import { useTranslation } from "react-i18next";

const HomeComp = (props) => {
  const [showHome, setShowHome] = useState(false);
  const [openTermsModal, setOpenTermsModal] = useState(false);
  const toggleTerms = () => setOpenTermsModal(!openTermsModal);
  const [openPrivacyModal, setOpenPrivacyModal] = useState(false);
  const togglePrivacy = () => setOpenPrivacyModal(!openPrivacyModal);
  const { t } = useTranslation();
  useEffect(() => {
    if (Cookies.get("token")) {
      setShowHome(false);
      props.history.push("/panel");
    } else {
      setShowHome(true);
    }
  }, []);
  const [language, setLanguage] = useState(
    Cookies.get("language") ? Cookies.get("language") : "en"
  );
  const handleEnLan = () => {
    setLanguage("en");
    Cookies.set("language", "en");
  };
  const handleFaLan = () => {
    setLanguage("fa");
    Cookies.set("language", "fa");
  };
  const handleKuLan = () => {
    setLanguage("ku");
    Cookies.set("language", "ku");
  };
  useEffect(() => {
    const lan = Cookies.get("language") ? Cookies.get("language") : "en";
    i18n.changeLanguage(lan);
    lan === "en"
      ? document.querySelector("body").classList.add("dirLTR")
      : document.querySelector("body").classList.remove("dirLTR");
  }, [language]);

  return (
    <>
      <ModalComp
        modal={openTermsModal}
        toggle={toggleTerms}
        component={<TermsAndConditions />}
      />
      <ModalComp
        modal={openPrivacyModal}
        toggle={togglePrivacy}
        component={<PrivacyPolicy />}
      />

      {showHome && (
        <div className="home w-100  text-white">
          <div className="position-absolute content d-flex justify-content-center align-items-center flex-column">
            <div className="flags-container">
              <div className="w-100 d-flex flex-row-reverse mb-4">
                <button className="flag-button" onClick={() => handleFaLan()}>
                  <img src={langFa} alt="Persian Flag" className="flag-icon" />
                </button>
                <button className="flag-button" onClick={() => handleEnLan()}>
                  <img src={langEn} alt="English Flag" className="flag-icon" />
                </button>
                {/* <button className="flag-button" onClick={() => handleKuLan()}>
                  <img src={langKu} alt="kurdi Flag" className="flag-icon" />
                </button> */}
                {/* <button
                className=" p-0 mx-2"
                style={{ height: "4vh", width: "3vw" }}
                onClick={handleEnLan}
              >
                <img src={langEn} className="w-100 h-100" />
              </button>
              <button
                className="p-0"
                style={{ height: "4vh", width: "3vw" }}
                onClick={handleFaLan}
              >
                <img src={langFa} className="w-100 h-100" />
              </button> */}
                {/* <button className="flag-button" onClick={() => handleFaLan()}>
                  <img
                    src={langTajik}
                    alt="tajik Flag"
                    className="flag-icon"
                    style={{ height: "2.2vh" }}
                  />
                </button> */}
              </div>
            </div>
            <div style={{ height: "20vh" }}>
              <img src={Logo} className="h-100" />
            </div>

            <div
              className="d-flex align-items-center"
              style={{ height: "20vh" }}
            >
              <h3>{t("هاب هوشمند ماندگار مدار آوین")}</h3>
            </div>
            <div style={{ height: "20vh" }}>
              <p>{t("از خانه خود لذت ببرید")}</p>
            </div>
            <div className="mb-3">
              <a
                className="LGButton bg-white text-dark mb-3"
                onClick={() => props.history.push("/login")}
              >
                {t("ورود")}
              </a>
              <a
                className="LGButton"
                onClick={() => props.history.push("/register")}
              >
                {t("ثبت نام")}
              </a>
            </div>
            <div className="fn12">
              {/* <a className="mx-2" onClick={toggleTerms}>
                {t("شرایط و قوانین")}
              </a> */}
              {/* | */}
              {/* <a className="mx-2" onClick={togglePrivacy}>
                {t("حریم خصوصی")}
              </a> */}
            </div>
          </div>
          <div className="position-absolute bghome w-100"></div>
        </div>
      )}
    </>
  );
};

const Home = withRouter(HomeComp);

export { Home };
